var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLoop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "loop"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M9 3V0.75L6 3.75L9 6.75V4.5C11.4825 4.5 13.5 6.5175 13.5 9C13.5 9.7575 13.3125 10.4775 12.975 11.1L14.07 12.195C14.655 11.2725 15 10.1775 15 9C15 5.685 12.315 3 9 3ZM9 13.5C6.5175 13.5 4.5 11.4825 4.5 9C4.5 8.2425 4.6875 7.5225 5.025 6.9L3.93 5.805C3.345 6.7275 3 7.8225 3 9C3 12.315 5.685 15 9 15V17.25L12 14.25L9 11.25V13.5Z",
    fill: "#008F8F"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoop);
export default __webpack_public_path__ + "static/media/Loop.5a1b208d02b43e355f77749f3542ae9d.svg";
export { ForwardRef as ReactComponent };